var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFramer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "3.7 3.7 43.6 43.6",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m47.3 3.7v21.8l-10.9 10.9-10.9 10.9-10.9-10.9 10.9-10.9v.1-.1z",
    fill: "#59529d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m47.3 25.5v21.8l-10.9-10.9z",
    fill: "#5271b4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.5 25.5-10.9 10.9-10.9 10.9v-43.6l10.9 10.9z",
    fill: "#bb4b96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramer);
export default __webpack_public_path__ + "static/media/Framer.cd0e8acf350dd639e9e8c999f8539a5e.svg";
export { ForwardRef as ReactComponent };